import { deleteOnboardingServiceApi as generatedDeleteOnboardingServiceApi } from '../generated/onboarding/deleteOnboardingService';

import { getOnboardProfileDraftApi } from './getOnboardProfileDraft';

const deleteOnboardingServiceApi = generatedDeleteOnboardingServiceApi.enhanceEndpoints({
  endpoints: {
    deleteOnboardingService: {
      invalidatesTags: ['Onboard'],
      onQueryStarted: async ({ serviceId }, { dispatch, queryFulfilled }) => {
        const patchResult = dispatch(
          getOnboardProfileDraftApi.util.updateQueryData('getOnboardProfileDraft', undefined, (draft) => {
            if (draft.services != null) {
              draft.services = draft.services.filter((service) => service._id !== serviceId);

              if (draft.progress != null) {
                draft.progress.services = draft.services.length > 0;
              }
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    },
  },
});

export const { useDeleteOnboardingServiceMutation } = deleteOnboardingServiceApi;
